import React, {Component} from 'react'
import {PropTypes} from 'prop-types'
import ReactTooltip from 'react-tooltip'
import {event} from '@cred/shared/ga'
import {Analytics} from '@cred/react-analytics'
import {isClient} from '@cred/shared/utils'
import styles from './styles.module.scss'

class Tooltip extends Component {
  static propTypes = {
    pinned: PropTypes.bool,
    effect: PropTypes.string,
    open: PropTypes.any,
    className: PropTypes.string,
    children: PropTypes.object.isRequired,
    gaCategory: PropTypes.string,
    gaAction: PropTypes.string,
    gaLabel: PropTypes.string,
    showTooltipOnce: PropTypes.bool,
    showClosingX: PropTypes.bool,
    tooltipType: PropTypes.string,
    forceOpenTooltip: PropTypes.bool
  }

  static defaultProps = {
    pinned: true,
    effect: 'solid',
    open: undefined,
    className: '',
    gaCategory: '',
    gaAction: '',
    gaLabel: '',
    showTooltipOnce: false,
    showClosingX: false,
    tooltipType: 'light',
    forceOpenTooltip: false
  }

  static instanceCounter = 0
  static instancesRefsList = []

  constructor(props) {
    super(props)
    this.id = ++Tooltip.instanceCounter
    this.analytics = new Analytics(props.analytics)
    this.state = {stopDisplayingAfterShow: !props.forceOpenTooltip}
  }

  componentDidMount() {
    const {pinned} = this.props

    this.componentDidUpdate()
    if (this.tooltip && pinned) {
      document.addEventListener('scroll', this.onScroll)
    }
  }

  componentDidUpdate() {
    const {open, analytics} = this.props

    this.analytics = new Analytics(analytics)

    if (open === true) {
      this.tooltip.setState({
        show: true,
        type: 'light',
        place: 'bottom',
        placeholder: this.getContent()
      })
    }

    if (open === false) {
      this.tooltip.setState({show: false})
    }
  }

  componentWillUnmount() {
    Tooltip.instancesRefsList = Tooltip.instancesRefsList.filter(
      tooltip => tooltip.id !== this.id
    )
    document.removeEventListener('scroll', this.onScroll)
  }

  onScroll = () => {
    if (this.tooltip.state.show) {
      this.tooltip.updatePosition()
    }
  }

  setTooltipRef = tooltip => {
    this.tooltip = tooltip
    Tooltip.instancesRefsList.push({
      id: this.id,
      ref: this.tooltip
    })
  }

  getContent = () => {
    const {children, showClosingX} = this.props

    return (
      <div className={`${styles.tooltipContent} tooltip__content`}>
        {children}
        {showClosingX ?
          <div onClick={this.onClose} className={styles.closingWrapper}>
            <i className="cred-icon icon-close"/>
          </div>
         :
          ''
        }
      </div>
    )
  }

  id = null

  closeAnotherInstances = () => {
    Tooltip.instancesRefsList.forEach(tooltip => {
      if (tooltip.ref && tooltip.id !== this.id) {
        tooltip.ref.setState({show: false})
      }
    })
  }

  onClose = () => {
    Tooltip.instancesRefsList.forEach(tooltip => {
      if (tooltip.ref && tooltip.id === this.id) {
        tooltip.ref.setState({show: false})
      }
    })

    this.setState({stopDisplayingAfterShow: true})
  }

  afterHide = () => {
    this.setState({stopDisplayingAfterShow: true})
    this.analytics.event({action: 'hide'})
  }

  afterShowHandler = () => {
    const {gaCategory, gaAction, gaLabel} = this.props

    this.closeAnotherInstances()
    if (gaCategory && gaAction) {
      event({category: gaCategory, action: gaAction, label: gaLabel})
    }
    this.analytics.event({action: 'show'})
  }

  render() {
    const {
        className,
        open,
        pinned,
        effect,
        showTooltipOnce,
        tooltipType,
        ...props
      } = this.props,
      {stopDisplayingAfterShow} = this.state,
      manualMode = open !== undefined,
      manualCss = manualMode ? styles.manual : null,
      click = manualMode ? undefined : 'click',
      showTooltip = isClient() &&
        (!showTooltipOnce || showTooltipOnce && !stopDisplayingAfterShow)

    return (
      <div className={manualCss}>
        {showTooltip &&
          <ReactTooltip
            ref={this.setTooltipRef}
            scrollHide={!pinned}
            event={click}
            afterShow={this.afterShowHandler}
            afterHide={this.afterHide}
            globalEventOff={click}
            effect={effect}
            type={tooltipType}
            className={className}
            {...props}
          >
            {this.getContent()}
          </ReactTooltip>
        }
      </div>
    )
  }
}

export {Tooltip}
export default Tooltip
